"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState } from "react";
export default function BlogHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const [isPulsing, setIsPulsing] = useState(false);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;
    const interval = setInterval(() => {
      setIsPulsing(true);
      setTimeout(() => setIsPulsing(false), 600);
    }, 8000);
    return () => clearInterval(interval);
  }, []);
  return <section ref={ref} className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/blog_hero_study_space.png)]">
      <div className="absolute inset-0 bg-gradient-to-b from-primary/60 to-primary/40 backdrop-blur-sm" />

      <div className={`relative z-10 mx-auto max-w-4xl px-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
        <Card className="glass-effect border border-muted/30 bg-background/80 px-8 py-10 shadow-strong backdrop-blur-md md:px-12 md:py-14">
          <CardContent className="space-y-6 px-0">
            <h1 className="font-display text-4xl font-bold leading-tight text-foreground md:text-5xl lg:text-6xl">Resources to Support Learning Beyond the Lesson</h1>
            
            <p className="text-lg leading-relaxed text-muted-foreground md:text-xl">
              Explore guidance, insights, and learning materials designed to support students and families beyond live sessions. This section includes our <strong>blog</strong>, <strong>downloadable e-books</strong>, and <strong>frequently asked questions</strong>, offering clear advice on study strategies, academic progress, and how our services work.
            </p>

            <p className="text-lg leading-relaxed text-muted-foreground md:text-xl">
              Additional resources, including <strong>courses, worksheets, assessments, and our digital learning platform</strong>, are currently in development and will be introduced over time.
            </p>

            <div className="pt-4">
              <Button asChild className={`btn-primary shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isPulsing ? "scale-103" : "scale-100"}`}>
                <Link to="/calendar">Book a Free Consultation</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}